import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { WorkspacePanel, WorkspaceBody } from "./WorkspacePanel";

const TABS = [
  { to: "/admin", end: true, labelKey: "admin.nav.dashboard", icon: "bi-speedometer2" },
  { to: "/admin/analytics", labelKey: "admin.nav.analytics", icon: "bi-graph-up" },
  { to: "/admin/companies", labelKey: "admin.nav.companies", icon: "bi-building" },
  { to: "/admin/users", labelKey: "admin.nav.users", icon: "bi-people" },
  { to: "/admin/feedback", labelKey: "admin.nav.feedback", icon: "bi-headset" },
];

export default function AdminShell({ children, title }) {
  const { t } = useTranslation();
  const { user } = useAuth();

  if (!user?.is_admin) {
    return (
      <div className="alert alert-danger">
        <i className="bi bi-shield-lock me-2"></i>
        {t("admin.forbidden")}
      </div>
    );
  }

  return (
    <WorkspacePanel testId="admin-shell">
      <div className="flex-shrink-0">
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <h4 className="fw-bold mb-0">
            <i className="bi bi-shield-check me-2 text-primary"></i>
            {title || t("admin.title")}
          </h4>
          <a
            href="https://metrika.yandex.ru/dashboard?id=109690764"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm btn-outline-secondary"
          >
            <i className="bi bi-box-arrow-up-right me-1"></i>
            {t("admin.open_metrika")}
          </a>
        </div>

        <ul className="nav nav-pills flex-wrap gap-1 mb-3">
          {TABS.map((tab) => (
            <li className="nav-item" key={tab.to}>
              <NavLink
                to={tab.to}
                end={tab.end}
                className={({ isActive }) =>
                  `nav-link py-1 px-3 ${isActive ? "active" : "text-dark"}`
                }
              >
                <i className={`bi ${tab.icon} me-1`}></i>
                {t(tab.labelKey)}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>

      <WorkspaceBody>{children}</WorkspaceBody>
    </WorkspacePanel>
  );
}
